import { Component, Output, EventEmitter, Input } from '@angular/core';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { NotifyService } from 'src/app/Services/notify.service';


@Component({
  selector: 'ze-file-upload-dn-d',
  templateUrl: './file-upload-dn-d.component.html',
  styleUrls: ['./file-upload-dn-d.component.scss']
})
export class FileUploadDnDComponent {
  public files: NgxFileDropEntry[] = [];
  @Output("file") emitFile = new EventEmitter();
  @Output("onReset") onReset = new EventEmitter();
  @Input("reset") resetFile: Boolean = false;
  constructor(private notifyService: NotifyService) { }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (file.name.toLowerCase().endsWith('.csv')) {
            this.emitFile.emit(file);
          } else {
            this.notifyService.notify('error', 'Invalid File', 'Only .csv files are allowed.');
            this.files = [];
          }
        });
      } else {
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }
  reset() {
    this.onReset.emit(true);
  }
  public fileOver(event) {
  }
  public fileLeave(event) {
  }
}